import { IPartnerState } from './interface/IPartnerState'

export const initialState: IPartnerState = {
  list: undefined,
}
